module.exports = __webpack_public_path__ + "assets/avatar.f6d4e6b2cf77cc0ef3b9cb8e0a18c62fa1b2203f778342b8a7a0649df1ea7d9e.jpg";